import BaseObject from "@shared/BaseObject.js";
import {ReviewPromptStateDefault} from "@/core/modules/review/ReviewPromptConstants";

export default class ReviewPromptManager extends BaseObject {

	getState(userProfile) {
		let reviewPromptState = {
			...ReviewPromptStateDefault,
			...(userProfile?.reviewPromptState || {}),
		}
		reviewPromptState.meaningfulUsageAtMap = {
			...(ReviewPromptStateDefault.meaningfulUsageAtMap || {}),
			...(reviewPromptState.meaningfulUsageAtMap || {}),
		}
		userProfile.reviewPromptState = reviewPromptState
		return reviewPromptState
	}

	isEligibleNow(reviewPromptState, now = Date.now()) {
		return reviewPromptState.eligibleAt > 0 && reviewPromptState.eligibleAt <= now
	}

	isBlocked(reviewPromptState, now = Date.now()) {
		return reviewPromptState.blockUntil > now
	}

	isSnoozed(reviewPromptState, now = Date.now()) {
		return reviewPromptState.snoozedUntil > now
	}

	isCompleted(reviewPromptState) {
		return reviewPromptState.completedAt > 0
	}

	canAsk(reviewPromptState, now = Date.now(), options = {}) {
		let {maxDismissCount = 2} = options
		let canAsk = !this.isCompleted(reviewPromptState)
		if(canAsk){
			canAsk = !this.isBlocked(reviewPromptState, now)
		}
		if(canAsk){
			canAsk = !this.isSnoozed(reviewPromptState, now)
		}
		if(canAsk){
			canAsk = this.isEligibleNow(reviewPromptState, now)
		}
		if(canAsk){
			canAsk = reviewPromptState.dismissCount < maxDismissCount
		}
		return canAsk
	}

	markShown(reviewPromptState, now = Date.now()) {
		reviewPromptState.shownAt = now
		return reviewPromptState
	}

	markEligible(reviewPromptState, now = Date.now()) {
		if(reviewPromptState.eligibleAt <= 0){
			reviewPromptState.eligibleAt = now
		}
		return reviewPromptState
	}

	markBlocked(reviewPromptState, blockUntil) {
		reviewPromptState.blockUntil = Math.max(reviewPromptState.blockUntil || 0, blockUntil || 0)
		return reviewPromptState
	}

	markSnoozed(reviewPromptState, snoozedUntil) {
		reviewPromptState.snoozedUntil = Math.max(reviewPromptState.snoozedUntil || 0, snoozedUntil || 0)
		return reviewPromptState
	}

	markDismissed(reviewPromptState, options = {}) {
		let {
			now = Date.now(),
			snoozedUntil = 0,
			increaseDismissCount = true,
		} = options
		if(increaseDismissCount){
			reviewPromptState.dismissCount = (reviewPromptState.dismissCount || 0) + 1
		}
		if(snoozedUntil > 0){
			this.markSnoozed(reviewPromptState, snoozedUntil)
		}
		if(reviewPromptState.shownAt <= 0){
			reviewPromptState.shownAt = now
		}
		return reviewPromptState
	}

	markCompleted(reviewPromptState, options = {}) {
		let {
			now = Date.now(),
			reason = "",
		} = options
		reviewPromptState.completedAt = now
		reviewPromptState.completionReason = reason
		return reviewPromptState
	}
}
